export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => (element, parentModule) => {
      if (parentModule) {
        let components = rootGetters['componentColumnModule/elements'](element, parentModule).components
        return Object.prototype.hasOwnProperty.call(element, 'componentComponent') ? components[element.componentComponent] : components
      }
      let components = rootGetters['componentColumnModule/elements'](element).components
      return Object.prototype.hasOwnProperty.call(element, 'componentComponent') ? components[element.componentComponent] : components
    },
    name: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).name,
    id: (state, getters) => element => getters.elements(element).id,
    index: (state, getters) => (element, id, parentModule) => getters.elements(element, parentModule).findIndex(component => component.id == id),
    assets: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).assets,
    styles: (state, getters) => (element, styles = 'styles', parentModule) => getters.elements(element, parentModule)[styles],
    content: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).content,
    properties: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).properties,
    classes: (state, getters) => (element, classes = 'classes', parentModule) => getters.elements(element, parentModule)[classes],
    background: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).background,
  },
  actions: {
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'componentComponentModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'componentComponentModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'componentComponentModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'componentComponentModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
  }
}